'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PolicyCreateScreen } from '../-components/PolicyCreateScreen';
import { parsePolicyDomain } from '../-utils/policyDomain';
import { PolicyCreateSearchSchema } from '../-zod-schema';
export const Route = createFileRoute('/_staff/settings/notification-and-response/notification-policies/new/')({
  validateSearch: zodValidator(PolicyCreateSearchSchema),
  component: NotificationPolicyCreate
});
function NotificationPolicyCreate() {
  const {
    domain: domainSearch
  } = Route.useSearch();
  const createDomain = parsePolicyDomain(domainSearch);
  return <PolicyCreateScreen createDomain={createDomain} />;
}